import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, ThemeEvents } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #handleCartUpdate = () => {
    requestAnimationFrame(() => {
      this.#restoreModalIfNeeded();
    });
  };

  /**
   * Re-promotes the dialog to the browser top layer after cart section morphs.
   */
  #restoreModalIfNeeded() {
    const { dialog } = this.refs;

    if (!dialog) return;

    if (dialog.open && !dialog.matches(':modal')) {
      dialog.removeAttribute('open');
      this.showDialog();
    }
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-total-dropdown')) {
      const cartDropdown = document.querySelector('.cart-total-dropdown');
      const totalContainer = document.querySelector('.cart__original-total-container');
      if (totalContainer) {
        totalContainer.classList.toggle('hidden');
        cartDropdown.classList.toggle('open');
      }
    }
  });
});
